import { Typography } from "@material-ui/core";
import { get, isEmpty } from "lodash";
import moment from "moment";
import React from "react";
import { useRecordContext } from "react-admin";

interface ICustomDateField {
  source: string;
  isDateTime?: boolean;
  label?: string;
  emptyText?: string;
  record?: any;
}

const CustomDateField = ({
  source,
  isDateTime,
  record = {},
}: ICustomDateField) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;
  const format = isDateTime ? "DD / MM / YYYY, hh:mm A" : "DD / MM / YYYY";

  const date = get(records, source);

  return (
    <Typography variant="body2">
      {date === undefined || date === null
        ? `-`
        : moment.utc(date).format(format)}
    </Typography>
  );
};

export default CustomDateField;
